<template>
  <v-row class="fill-height">
    <v-col class="fill-height">
      <!-- Table -->
      <v-row class="ma-0 pa-0 d-flex justify-center" elevation="4">
        <v-col class="pa-0 ma-0">
          <v-data-table
            :headers="headers"
            item-key="d_id"
            :items="carts"
            class="elevation-4 my-page3-table"
            dark
            loading-text="資料更新中..."
            no-data-text="未選擇產品,請至產品時價挑選"
            :mobile-breakpoint="1"
          >
            <template v-slot:top>
              <v-row><v-col></v-col></v-row>
            </template>
            <template v-slot:item.count="{ item }">
              <v-text-field
                v-model="item.count"
                label="數量"
                class="ma-0 pa-0"
                type="number"
                hide-details
                single-line
                min="1"
                dense
                :rules="inputRules"
                @input="handleOnChnageSellCount(item, item.count)"
              ></v-text-field>
            </template>

            <template v-if="!isChangeSellCount" v-slot:item.profile="{ item }">
              {{ item.profile }}
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn @click="handleOnDeleteSellItem(item)" icon>
                <v-icon>
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>

            <template v-slot:body.append>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{ total }}</td>
                <td></td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <!-- Contact -->
      <v-card
        class="ma-0 pa-0 mt-sm-4 my-page3-contact-card"
        elevation="4"
        dark
      >
        <v-card-title>
          <h3>聯絡資料</h3>
        </v-card-title>

        <v-card-text class="pb-0">
          <v-form ref="my-page3-form" v-model="InputValid" @submit.prevent="">
            <!-- Name... -->
            <v-row>
              <v-col>
                <v-text-field
                  v-model="contactName"
                  label="姓名"
                  :rules="InputRules"
                  :counter="10"
                  require
                  :disabled="status2.loggedIn"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="contactPhone"
                  label="電話"
                  :rules="phoneRules"
                  :counter="18"
                  @keydown.space.prevent=""
                  :disabled="status2.loggedIn"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="contactLine"
                  label="LineID"
                  :counter="32"
                  @keydown.space.prevent=""
                  :disabled="status2.loggedIn"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Material -->
            <v-row>
              <v-col class="pt-0 pb-0">
                <v-textarea
                  v-model="contactMaterial"
                  label="匯款資料"
                ></v-textarea>
              </v-col>
            </v-row>
            <!-- Memo -->
            <v-row>
              <v-col class="pt-0 pb-0">
                <v-textarea v-model="contactMemo" label="備註"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="pt-0">
          <v-row class="pr-1 text-end">
            <v-col class="pt-0">
              <v-btn
                elevation="4"
                color="success"
                @click="handleOnSave"
                :loading="isUpdating3"
              >
                <v-icon>mdi-content-save</v-icon>
                提交
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <!--  -->
      <v-bottom-sheet v-model="sheet" inset>
        <v-sheet class="text-center my-page3-sheet" height="80px">
          <v-row class="ma-0 fill-height">
            <v-col class="pa-0">
              <v-alert
                prominent
                text
                :type="submitQuoteResult.res ? 'success' : 'error'"
              >
                <div class="d-inline-block">
                  <h2>{{ sheetContent }}</h2>
                </div>
                <!-- <div class="d-inline-flex"> -->
                <!-- <div>
                  <v-btn
                    icon
                    color="error"
                    @click="sheet = !sheet"
                    absolute
                    top
                    right
                  >
                    <v-icon>mdi-close-thick</v-icon>
                  </v-btn>
                </div> -->
                <v-btn
                  icon
                  color="error"
                  @click="sheet = !sheet"
                  absolute
                  top
                  right
                >
                  <v-icon>mdi-close-thick</v-icon>
                </v-btn>
              </v-alert>
            </v-col>
          </v-row>
        </v-sheet>
      </v-bottom-sheet>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapActions, mapState, mapMutations } from 'vuex'
export default {
  data: () => {
    return {
      isChangeSellCount: false,
      // #region Table
      headers: [
        {
          class: 'my-th',
          text: '品牌',
          align: 'start',
          value: 'b_name'
        },
        {
          class: 'my-th',
          text: '系列',
          align: 'start',
          value: 's_name'
        },
        {
          class: 'my-th',
          text: '型號',
          align: 'start',
          value: 'model'
        },
        {
          class: 'my-th',
          text: '價格',
          align: 'start',
          value: 's_price'
        },
        {
          class: 'my-th',
          text: '數量',
          align: 'start',
          value: 'count'
        },
        {
          class: 'my-th',
          text: '小計',
          align: 'start',
          value: 'profile'
        },
        {
          class: 'my-th',
          text: '',
          align: 'start',
          value: 'actions',
          sortable: false
        }
      ],
      inputRules: [
        v => Number(v) >= 0 || '必須是正整數',
        v => Number.isInteger(Number(v)) || '必須是整數',
        v => !!v || '不可空白'
      ],
      total: 0,
      // #endregion

      // #region Contact
      contactId: '',
      contactName: process.env.NODE_ENV === 'development' ? '姓名測' : '',
      contactPhone: process.env.NODE_ENV === 'development' ? '1234567890' : '',
      contactLine: '',
      contactMaterial: '',
      contactMemo: '',
      InputValid: false,
      InputRules: [
        v => !!v || '不可空白',
        v => v.length <= 10 || '不可超過10個字'
      ],
      phoneRules: [
        v => !!v || '不可空白',
        v => Number.isInteger(Number(v)) || '必須是數字',
        v => v.length === 10 || '字數錯誤'
      ],
      // #endregion

      sheet: false,
      sheetContent: '1111111111111111111111111'
    }
  },
  computed: {
    ...mapState('account', ['status2', 'user_id', 'tag', 'user', 'uid']),
    ...mapState('forward', [
      'quoteContact',
      'isUpdating3',
      'carts',
      'cartsIdxs',
      'submitQuoteResult'
    ]),
    list() {
      const o = []
      this.carts.forEach(e => {
        if (typeof e !== 'undefined') o.push(e)
      })
      return o
    }
  },
  methods: {
    ...mapActions('forward', ['getContact', 'submitQuote']),
    ...mapMutations('forward', ['removeFromCarts', 'clearCarts']),
    handleOnChnageSellCount(item, count) {
      item.profile = item.s_price * count
      this.cTotal()
      this.isChangeSellCount = true
      this.$nextTick(() => {
        this.isChangeSellCount = false
      })
    },
    handleOnDeleteSellItem(item) {
      const id = item.d_id
      for (let i = 0; i < this.carts.length; i++) {
        if (this.carts[i].d_id === id) {
          this.removeFromCarts(i)
          break
        }
      }
      this.cTotal()
    },
    cTotal() {
      this.total = 0
      this.list.forEach(e => {
        this.total += e.profile
      })
    },
    handleOnSave() {
      if (this.carts.length < 1) {
        this.sheetContent = '請回到時價選取產品'
        this.sheet = true
        return
      }
      if (!this.$refs['my-page3-form'].validate()) {
        if (this.status2.loggedIn) {
          this.sheetContent = '請聯絡管理員,補齊會員聯絡資料'
          this.sheet = true
        }
        return
      }
      if (!confirm('確定送出嗎?')) return

      const quote = {
        create_id: { value: this.user_id, type: 'i' },
        tag: { value: this.tag, type: 'i' },
        total: { value: this.total, type: 'i' },
        name: { value: this.contactName, type: 's' },
        phone: { value: this.contactPhone, type: 's' },
        line: { value: this.contactLine, type: 's' },
        material: { value: this.contactMaterial, type: 's' },
        memo: { value: this.contactMemo, type: 's' }
      }

      const quoteList = []
      this.carts.forEach(e => {
        quoteList.push({
          detail_id: e.d_id,
          u_price: e.s_price,
          amount: e.count,
          s_total: e.profile
        })
      })
      ;(async () => {
        const { user, uid } = this
        await this.submitQuote({ quote, quoteList, user, uid })
        if (this.submitQuoteResult.res === true) {
          this.clearCarts()
          // this.contactName = ''
          // this.contactPhone = ''
          // this.contactLine = ''
          // this.contactMaterial = ''
          // this.contactMemo = ''

          this.sheetContent = '送出成功'
        } else {
          this.sheetContent = '送出失敗, 請聯絡管理員'
        }
        this.sheet = true

        this.total = 0
      })()
    }
  },
  created() {
    this.$emit('setTab')
    this.cTotal()
    //
    if (!this.status2.loggedIn) return
    ;(async () => {
      const { user_id, tag, user, uid } = this
      await this.getContact({ user_id, tag, user, uid })
      this.contactName = this.quoteContact.name
      this.contactPhone = this.quoteContact.phone
      this.contactLine = this.quoteContact.line
      this.contactMaterial = this.quoteContact.material
      this.contactMemo = this.quoteContact.memo
    })()
  }
}
</script>

<style lang="scss">
.my-page3-table,
.my-page3-contact-card {
  background-color: rgba(37, 37, 37, 0.9) !important;
}

.my-page3-table {
  th {
    vertical-align: top !important;
  }

  th,
  td {
    font-size: 18px;
    padding-right: 5px !important;
    padding-left: 5px !important;
  }

  .v-input {
    width: 60px !important;
  }
}

.my-page3-sheet {
  .v-btn {
    margin-right: -15px !important;
    margin-top: -15px !important;
  }
}

.my-page3-contact-card {
  .v-btn {
    font-size: 22px !important;
  }
}

@media screen and (max-width: 600px) {
  .my-page3-table {
    .v-input {
      font-size: 24px;
    }

    table {
      th,
      td {
        font-size: 24px !important;
      }
    }
  }

  .my-page3-contact-card {
    .v-input {
      font-size: 22px !important;

      label {
        font-size: 22px !important;
      }

      .v-counter {
        font-size: 20px !important;
      }
    }
  }
}
</style>
